'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixChild = require('../utils/mix-child.js');

exports.default = {
  mixins: [(0, _mixChild.mixChild)('dof-row')],
  computed: {
    style: function style() {
      var res = {};
      return res;
    },
    borderRightPadding: function borderRightPadding() {
      return this.$parent.borderRightPadding;
    },
    borderBottomPadding: function borderBottomPadding() {
      return this.$parent.borderBottomPadding;
    },
    isShowBorderRight: function isShowBorderRight() {
      return this.$parent.isShowBorderRight;
    },
    isShowBorderBottom: function isShowBorderBottom() {
      return this.$parent.isShowBorderBottom;
    },
    isShowDelta: function isShowDelta() {
      return this.$parent.isShowDelta;
    },
    padding: function padding() {
      return this.$parent.paddingHorizontal + 'px';
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-numcard-col/index.vue
// module id = 358
// module chunks = 0 1